import type { EntityFilter } from "../model";

export function intersectArrays<T>(...arrs: T[][]): T[] {
    let intersection = arrs.pop() || [];

    while (arrs.length) {
        const compare = arrs.pop()!;
        intersection = intersection.filter((each) => compare.includes(each));
    }

    return intersection;
}

export function groupBy<T>(list: T[], keyGetter: (item: T) => PropertyKey): Record<PropertyKey, T[]> {
    const obj: Record<PropertyKey, T[]> = {};
    list.forEach((item) => {
        const key = keyGetter(item);

        const collection = obj[key];
        if (!collection) {
            obj[key] = [item];
        } else {
            collection.push(item);
        }
    });
    return obj;
}

export function haveFiltersChanged(a: EntityFilter[], b: EntityFilter[]) {
    return (
        a.length !== b.length ||
        a.some((filterA) => !b.some((filterB) => filterB.type === filterA.type && filterB.value === filterA.value))
    );
}